import { Fragment, h } from "preact"
import { useHistory } from "react-router-dom"
import './card-dashboard-styles.scss'
import { isMobileAgent } from "../../common"
import TrialBadge from "../TrialBadge"


export default function Card({ title, content, to, external, externalInWindow, inverse, fullWidth, disabled, className, id }) {
    const history = useHistory()

    const handleClick = () => {
        if (disabled) return

        if (external) {
            window.open(to, '_blank').focus()
        } else if (externalInWindow) {
            window.open(to, '_self').focus()
        }
        else {
            history.push(to)
        }
    }

    return (
        <div id={id} className={`
                d-flex flex-column space-between
                ${fullWidth && isMobileAgent() ? 'card-dashboard-full-width' : 'card-dashboard'}
                ${inverse ? 'inverse' : ''}
                ${disabled && 'cursor-not-allowed'}
                ${className}
            `} onClick={handleClick}>
            <div className='card-dashboard__header'>
                {title && <p className={`${disabled && 'txt-disabled-light'}`}>{title}</p>}
                <i className={`far fa-arrow-right ${disabled && 'txt-disabled-light'}`} />
            </div>
            <div>
                {content && <div
                    className={`card-dashboard__content ${disabled && 'txt-disabled-light'}`}
                >{content}</div>}
            </div>
            {disabled &&
                <div className='flex-align-self-end m-top-auto p-top'>
                    <TrialBadge />
                </div>
            }
        </div>
    )
}
